export default __webpack_public_path__ + "static/media/Icons-Website.7049537f.svg";